import React, { useEffect, useRef } from "react";
import "./css/OurMissionSection.css";

export default function OurMissionSection({ title, subtitle, paragraph, backgroundImage, backgroundSize, backgroundPosition }) {
  const sectionRef = useRef(null);
  const bgRef = useRef(null);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          if (!sectionRef.current || !bgRef.current) return;
          const rect = sectionRef.current.getBoundingClientRect();
          const viewH = window.innerHeight;
          const progress = (viewH - rect.top) / (viewH + rect.height);
          const shift = (progress - 0.5) * 100;
          bgRef.current.style.transform = `translateY(${shift}px)`;
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="ovs-parallax-section" ref={sectionRef}>

      <div className="ovs-parallax-bg" ref={bgRef} style={{backgroundImage:backgroundImage, backgroundSize: backgroundSize, backgroundPosition: backgroundPosition}}/>
      <div className="ovs-parallax-overlay" />

      <div className="customcontainer">
        <div className="ovs-parallax-content">
          <span className="ovs-parallax-tag">{title}</span>
          <h2 className="ovs-parallax-heading">
           {subtitle}
          </h2>
          <div className="ovs-parallax-divider" />
          <p className="ovs-parallax-para">
            {paragraph}
          </p>
        </div>
      </div>

    </section>
  );
}